import { languageService } from "../../../../Language/language.service";
import { TableCellScrollable } from "../../Helper/TableUtils";

export const hosTemplateReportingPeriodTableSchema = [
  {
    Header: languageService("Duty Type"),
    accessor: "dutyType",
    id: "dutyType",
    minWidth: 125,
  },
  {
    Header: languageService("Service Type"),
    accessor: "serviceType",
    id: "serviceType",
    minWidth: 125,
  },
  {
    Header: languageService("Location"),
    id: "location",
    accessor: (d) => {
      const startLoc = d.startLoc ? d.startLoc.description : "";
      const endLoc = d.endLoc ? d.endLoc.description : "";
      return `${startLoc} - ${endLoc}`;
    },
    minWidth: 125,
  },
  {
    Header: languageService("Start Date"),
    id: "startDate",
    accessor: "startDate",
    minWidth: 100,
  },
  {
    Header: languageService("Start Time"),
    id: "startTime",
    accessor: "startTime",
    minWidth: 100,
  },
  {
    Header: languageService("End Date"),
    id: "endDate",
    accessor: "endDate",
    minWidth: 100,
  },
  {
    Header: languageService("End Time"),
    id: "endTime",
    accessor: "endTime",
    minWidth: 100,
  },
  {
    Header: languageService("Activity"),
    accessor: "activityType.value",
    id: "activityType",
    minWidth: 130,
  },
  {
    Header: languageService("Comments"),
    accessor: "comments",
    id: "comments",
    minWidth: 275,
    Cell: TableCellScrollable,
  },
];



// WEBPACK FOOTER //
// ./src/components/HoursOfService/EntryTemplates/schemas/hosTemplateReportingPeriodTableSchema.js